window.NIL_FILTER_TAXONOMY = {
  priceRanges: [
    { label: 'Under $1,000', min: 0, max: 1000 },
    { label: '$1,000 – $1,250', min: 1000, max: 1250 },
    { label: '$1,250 – $1,500', min: 1250, max: 1500 },
    { label: '$1,500 – $2,000', min: 1500, max: 2000 },
    { label: '$2,000 – $2,500', min: 2000, max: 2500 },
    { label: '$2,500+', min: 2500, max: 999999 }
  ],
  groups: [
    { id: 'colors', label: 'Colors', type: 'color_swatch', options: [
      { label: 'Ivory', key: 'ivory', aliases: ['ivory','soft-ivory','soft ivory','color-ivory'] },
      { label: 'White', key: 'white', aliases: ['white','color-white'] },
      { label: 'Champagne', key: 'champagne', aliases: ['champagne','color-champagne'] },
      { label: 'Nude', key: 'nude', aliases: ['nude','beige','color-nude'] },
      { label: 'Emerald Green', key: 'emerald-green', aliases: ['emerald-green','emerald green','color-emerald-green'] },
      { label: 'Navy Blue', key: 'navy-blue', aliases: ['navy-blue','navy blue','color-navy-blue'] },
      { label: 'Crimson Red', key: 'crimson-red', aliases: ['crimson-red','crimson red','red','color-crimson-red'] },
      { label: 'Teal Turquoise', key: 'teal-turquoise', aliases: ['teal-turquoise','teal turquoise','turquoise','color-teal-turquoise'] },
      { label: 'Dusty Rose', key: 'dusty-rose', aliases: ['dusty-rose','dusty rose','color-dusty-rose'] },
      { label: 'Deep Purple', key: 'deep-purple', aliases: ['deep-purple','deep purple','purple','color-deep-purple'] },
      { label: 'Gold Champagne', key: 'gold-champagne', aliases: ['gold-champagne','gold champagne','color-gold-champagne'] }
    ]},
    { id: 'silhouette', label: 'Silhouette', options: [
      { label: 'A-Line', key: 'a-line', aliases: ['a-line','aline','a line','silhouette-a-line'] },
      { label: 'Mermaid', key: 'mermaid', aliases: ['mermaid','balik','silhouette-mermaid'] },
      { label: 'Ball Gown', key: 'ball-gown', aliases: ['ball-gown','ball gown','princess','silhouette-ball-gown'] },
      { label: 'Princess', key: 'princess', aliases: ['princess','royal','silhouette-princess'] },
      { label: 'Sheath', key: 'sheath', aliases: ['sheath','straight','silhouette-sheath'] },
      { label: 'Fit and Flare', key: 'fit-and-flare', aliases: ['fit-and-flare','fit and flare','trumpet'] }
    ]},
    { id: 'length', label: 'Length', options: [
      { label: 'Cathedral Train', key: 'cathedral-train', aliases: ['cathedral-train','cathedral train','length-cathedral-train'] },
      { label: 'Chapel Train', key: 'chapel-train', aliases: ['chapel-train','chapel train','length-chapel-train'] },
      { label: 'Floor Length', key: 'floor-length', aliases: ['floor-length','floor length','long','length-floor-length'] },
      { label: 'Midi', key: 'midi', aliases: ['midi','midi-length'] },
      { label: 'Ankle', key: 'ankle', aliases: ['ankle','ankle-length'] },
      { label: 'Asymmetric', key: 'asymmetric', aliases: ['asymmetric','asymmetrical'] }
    ]},
    { id: 'fabrics', label: 'Fabrics', options: [
      { label: 'Lace', key: 'lace', aliases: ['lace','fabric-lace','french lace'] },
      { label: 'Tulle', key: 'tulle', aliases: ['tulle','fabric-tulle'] },
      { label: 'Satin', key: 'satin', aliases: ['satin','fabric-satin'] },
      { label: 'Mikado', key: 'mikado', aliases: ['mikado','fabric-mikado'] },
      { label: 'Chiffon', key: 'chiffon', aliases: ['chiffon','fabric-chiffon'] },
      { label: 'Organza', key: 'organza', aliases: ['organza','fabric-organza'] }
    ]},
    { id: 'neckline', label: 'Neckline', options: [
      { label: 'Sweetheart', key: 'sweetheart', aliases: ['sweetheart','neckline-sweetheart'] },
      { label: 'V-Neck', key: 'v-neck', aliases: ['v-neck','v neck','neckline-v-neck'] },
      { label: 'Strapless', key: 'strapless', aliases: ['strapless','neckline-strapless'] },
      { label: 'High Neck', key: 'high-neck', aliases: ['high-neck','high neck','neckline-high-neck'] },
      { label: 'Square Neck', key: 'square-neck', aliases: ['square-neck','square neck','neckline-square-neck'] },
      { label: 'Halter Neck', key: 'halter-neck', aliases: ['halter-neck','halter neck'] },
      { label: 'Collar', key: 'collar', aliases: ['collar','collared'] }
    ]},
    { id: 'sleeve-length', label: 'Sleeve Length', options: [
      { label: 'Sleeveless', key: 'sleeveless', aliases: ['sleeveless','sleeve-sleeveless'] },
      { label: 'Short Sleeve', key: 'short-sleeve', aliases: ['short-sleeve','short sleeve','sleeve-short-sleeve'] },
      { label: 'Long Sleeve', key: 'long-sleeve', aliases: ['long-sleeve','long sleeve','long-sleeves','illusion sleeve','sleeve-long-sleeve'] },
      { label: 'Off Shoulder', key: 'off-shoulder', aliases: ['off-shoulder','off shoulder','sleeve-off-shoulder'] },
      { label: 'Cap Sleeves', key: 'cap-sleeves', aliases: ['cap-sleeves','cap sleeves'] }
    ]},
    { id: 'size', label: 'Size', type: 'size_boxes', options: ['40','42','44','46','48','50','52','54','56','58'].map(function(x){ return { label: x, key: x, aliases: ['size-'+x, x] }; }) },
    { id: 'body-type', label: 'Body Type', options: [
      { label: 'Standard', key: 'standard', aliases: ['standard','body-type-standard'] },
      { label: 'Plus Size', key: 'plus-size', aliases: ['plus-size','plus size','big-size','curve','büyük beden','body-type-plus-size'] }
    ]},
    { id: 'embellishment', label: 'Embellishment', options: [
      { label: 'Lace', key: 'lace', aliases: ['lace','embellishment-lace'] },
      { label: 'Applique', key: 'applique', aliases: ['applique','appliqué','embellishment-applique'] },
      { label: 'Beaded', key: 'beaded', aliases: ['beaded','beading','embellishment-beaded'] },
      { label: 'Sequins', key: 'sequins', aliases: ['sequins','sequin','embellishment-sequins'] },
      { label: 'Pearl', key: 'pearl', aliases: ['pearl','pearls','embellishment-pearl'] },
      { label: 'Crystal', key: 'crystal', aliases: ['crystal','crystals','embellishment-crystal'] },
      { label: 'Bow', key: 'bow', aliases: ['bow','embellishment-bow'] },
      { label: '3D Floral', key: '3d-floral', aliases: ['3d-floral','3d floral','floral','embellishment-3d-floral'] }
    ]},
    { id: 'back-style', label: 'Back Style', options: [
      { label: 'Open Back', key: 'open-back', aliases: ['open-back','open back','low-back','low back','back-style-open-back'] },
      { label: 'Closed Back', key: 'closed-back', aliases: ['closed-back','closed back','back-style-closed-back'] },
      { label: 'V Back', key: 'v-back', aliases: ['v-back','v back','back-style-v-back'] },
      { label: 'Corset Back', key: 'corset-back', aliases: ['corset-back','corset back','back-style-corset-back'] },
      { label: 'Illusion Back', key: 'illusion-back', aliases: ['illusion-back','illusion back','back-style-illusion-back'] }
    ]}
  ],
  mostUsedTags: [
    { label: 'New Arrivals', key: 'new-arrivals', aliases: ['new-arrivals','new arrival','new'] },
    { label: 'Best Sellers', key: 'best-seller', aliases: ['best-seller','best seller','bestseller'] },
    { label: 'Minimal', key: 'minimal', aliases: ['minimal','simple','clean'] }
  ]
};
